<template>
  <div>
    <div class="form">
      <div class="form-item">
        <div class="label">公司简称</div>
          <div class="input"><input v-model="nickname" type="text" maxlength="20" placeholder="公司简称" ></div>
        </div>
        <div class="form-item">
          <div class="label">手机号</div>
          <div class="input"><input ref="mobile" v-model="mobile" type="number" placeholder="手机号码（系统登录使用，请认真填写）" @input="limitNum($refs.mobile, 'mobile', 11)"></div>
        </div>
        <div class="form-item">
          <div class="label">验证码</div>
          <div class="input">
            <input v-model="code" type="text" maxlength="6" placeholder="请输入短信验证码" >
            <div v-if="count === 60" class="code" :class="{ 'active': isSendSms }" @click="isSendSms ? sendSms() : null">发送验证码</div>
            <div v-else class="code">{{ count }}s 重新发送</div>
          </div>
        </div>
        <div class="form-item">
          <div class="label">密码</div>
          <div class="input">
            <input v-model="password" :type="!showPwd ? 'password' : 'text'" maxlength="20" placeholder="请输入8-20位密码，字母/数字/符号至少2种" >
            <van-icon :name="!showPwd ? 'closed-eye' : 'eye-o'" class="fs-24" @click="showPwd = !showPwd" />
          </div>
        </div>
        <span style="display: none;">{{ isFinished }}</span>
    </div>
  </div>
</template>

<script>
import LimitNum from '@/mixins/number-limit.js'
export default {
  name: 'SingleReg',
  mixins: [LimitNum],
  props: {
    count: {
      type: Number
    }
  },
  data() {
    return {
      showPwd: false, // 默认是密文
      nickname: '', // 艺名/乐队名/公司简称
      mobile: '',
      password: '',
      code: ''
    }
  },
  computed: {
    isSendSms() {
      return this.mobile.length  === 11
    },
    isFinished() {
      const { mobile, password, code, nickname } = this
      let isFinished = mobile && password && code && nickname && true || false
      this.$emit('finished', { isFinished, form: { mobile, password, code, nickname }})
      return isFinished
    }
  },
  methods: {
    sendSms() {
      this.$emit('sendSms')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/form.scss';
.form{
  margin-top: 0;
  .form-item{
    .input{
      color: #222;
    }
  }
}
</style>
